/**
 * 副导航
 */

import DeputyNavApi from '../../api/deputy.nav.api'
let curDeputyNav = window.sessionStorage.getItem('curDeputyNav') || ''
let searchPageId = window.sessionStorage.getItem('searchPageId') || ''

const state = {
	showDeputyNavEdit: false, //副导航编辑弹窗显示隐藏
	deputyNavOptions: {}, // 当前副编辑导航的属性参数
	curProjNavMenu: [], // 当前副导航数据
	showAddDeputyNav: false, //控制导航弹窗的显示隐藏
	isEditDeputyNav: false, //是否编辑过导航
	curNavMenuUnique: '', // 当前要添加的导航的order唯一标记
	isRequest: false,//副导航是否需要刷新
	curType: 'add',
	pageListData: [],
	curDeputyOptions: {},//当前导航编辑数据
	deputyLinkPage: [],
	deputyNavModal: false, // 导入以及设置外链弹窗
	deputyNavModalType: 'import', // import-导入相关页面   editHref-修改href
	curDeputyNav: curDeputyNav, //列表页第一页id
	searchPageId: searchPageId, //搜索页面id
	searchPageTxt: '',
	searchPageInfo: '',
	iframeType: '',
}
const getters = {
	getHandlePageListData: state => {
		let str = ''
		state.deputyLinkPage.forEach((item) => {
			str = str + ',' + item.relPageId
		})
		state.pageListData.forEach(item => {
			if (str.indexOf(item.pageId) !== -1) {
				item.selected = true
			} else {
				item.selected = false
			}
		})
		return state.pageListData
	}
}
const mutations = {
	setDeputyNavState (state, data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				state[key] = data[key]
			}
		}
	},
	SET_CUR_DEPUTY_NAV (state, data) {
		if (data) {
			window.sessionStorage.setItem('curDeputyNav', data)
		} else {
			window.sessionStorage.removeItem('curDeputyNav')
		}
		state.curDeputyNav = data
		state.iframeType = ''
	},
	SET_SEARCH_PAGE_ID (state, data) {
		if (data) {
			window.sessionStorage.setItem('searchPageId', data)
		} else {
			window.sessionStorage.removeItem('searchPageId')
		}
		state.searchPageId = data
	},
	SET_SEARCH_PAGE_TXT (state, data) {
		state.searchPageTxt = data
	},
	SET_SEARCH_PAGE_INFO (state, data) {
		state.searchPageInfo = data
	},
	SET_PROJ_LIST_IFRAME(state, data) {
		state.iframeType = data
	}
}
const actions = {
	getDetailPageList (context, params) {
		return DeputyNavApi.getDetailPageList(params)
	},
	addDeputyNavPage ({ state }, params) {
		return DeputyNavApi.addDeputyNavPage(params)
	},
	deputyPageImport ({
		state
	}, data) {
		return DeputyNavApi.deputyPageImport(data)
	},
	updateDeputyPage (context, data) {
		return DeputyNavApi.updateDeputyPage(data)
	},
	getDeputyImpPage (context, params) {
		return DeputyNavApi.getDeputyImpPage(params)
	},
	/**
	 * 设置外链
	 * @param {Object} params
	 */
	setDeputyOuterLink (context, params) {
		return DeputyNavApi.setDeputyOuterLink(params)
	}
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
